// @ts-expect-error Untyped module
import ExtensionInstallHelpers from 'ExtensionInstallHelpers/SidekickExtensionInstallHelpers';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { updateFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step'; // import { getIsActiveAndAssignedToVariantONBC008 } from '../../store/experiments/selectors';

export const ProductSetupUIBranch = {
  name: 'ProductSetupUIBranch',
  // FIXME: add correct state check
  // stateCheck: (state: RootAppState) => {
  //   return getIsActiveAndAssignedToVariantONBC008(state);
  // },
  stateCheck: () => false,
  rebuildFlow: (flow, state, dispatch) => {
    const hasSalesExtension = ExtensionInstallHelpers.hasExtension();
    const postAccountCreationSteps = [...getFlowSteps().postAccountCreation];
    const flowSteps = [...flow];

    if (!hasSalesExtension) {
      flowSteps.push(Step.InstallSalesExtension);
      postAccountCreationSteps.push(Step.InstallSalesExtension);
    }

    dispatch(updateFlow(getFlowSteps().preVerification, getFlowSteps().postVerification, postAccountCreationSteps, getFlowSteps().postExistingAccountSelection));
    return flowSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};